export interface FinalizingErrorState {
  hasError: boolean;
  message: string;
}

export const FINALIZING_ERROR_STATE_INITIAL: FinalizingErrorState = {hasError: false, message: ''};

/** The anchor is authored inside the lang string, so it is reached through the DOM rather than as a React child. */
export const REDIRECT_LINK_SELECTOR = 'a.redirect-link';
